import cn from "classnames";
import { useTranslation } from 'react-i18next';
import { Badge, BadgeType } from "@components/new/Badge";
import Checkbox from "@components/new/Checkbox";
import { Title3 } from "@components/new/Typo";
import { Marketplace } from "@components/new/Marketplace";
import { MarketplaceStoreGroup } from "@components/new/MarketplaceStoreGroup";
import { TSellerWarehouse } from "@api/apiClient/fbp";
import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import IconPen from '@assets/icons/outline/square-pen.svg?react';
import styles from './WarehouseSelectComponents.module.scss';

const Content = ({ item, option }: { item: TSellerWarehouse | null, option?: boolean }) => {
  if (!item) return null;

  const name = item.name ||
    (item.ymWarehouses?.length && item.ymWarehouses[0]?.name) ||
    (item.wbWarehouses?.length && item.wbWarehouses[0]?.warehouseName) ||
    (item.aliWarehouses?.length && item.aliWarehouses[0]?.name) ||
    "";

  return (
    <div className={cn(styles.content, option && styles.option)}>
      <div className={styles.contentItem}>
        <MarketplaceStoreGroup>
          {item.wbWarehouses?.length ? (<Marketplace name="Wildberries" />) : null}
          {item.ymWarehouses?.length ? (<Marketplace name="Yandex" />) : null}
          {item.aliWarehouses?.length ? (<Marketplace name="Aliexpress" />) : null}
        </MarketplaceStoreGroup>
        <Title3 ellipsis>{name}</Title3>
      </div>
    </div>
  )
}

export const getWarehouseSelectValue = ({ }: {
  editWarehouse: (item: TSellerWarehouse | null) => void;
  yAvailable: boolean;
  wbAvailable: boolean;
}) => ({ item }: { item: TSellerWarehouse | null }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.content}>
      <Content item={item} />
      {item?.isAwaitingDeletion ? (
        <Badge type={BadgeType.DESTRUCTIVE} className={styles.badge}>
          {t("fbpPage.removalInProces")}
        </Badge>
      ) : null}
    </div>
  );
}

export const getWarehouseSelectOption = ({ editWarehouse, yAvailable, wbAvailable, aliAvailable, onCheck, isChecked }: {
  editWarehouse: (item: TSellerWarehouse | null) => void;
  yAvailable: boolean;
  wbAvailable: boolean;
  aliAvailable: boolean;
  onCheck: (id: string) => void;
  isChecked: (id: string) => boolean;
}) => ({ item }: { item: TSellerWarehouse | null }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.content}>
      <div onClick={(e: any) => e.stopPropagation()}>
        <Checkbox
          checked={isChecked(item?.id ?? "")}
          onChange={() => onCheck(item?.id ?? "")}
          disabled={item?.isAwaitingDeletion}
        />
      </div>
      <Content item={item} option />
      {item?.isAwaitingDeletion ? (
        <Badge type={BadgeType.DESTRUCTIVE}>
          {t("fbpPage.removalInProces")}
        </Badge>
      ) : ((yAvailable || wbAvailable || aliAvailable) ? (
        <IconButton
          icon={IconPen}
          type={IconButtonType.ICON}
          size={IconButtonSize.S}
          onClick={(e: any) => {
            e.stopPropagation();
            editWarehouse(item);
          }}
        />
      ) : null)}
    </div>
  );
}
